var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as moment from 'moment';
import { TRADING_EVENT_TYPE } from '../util/constants';
import { transformCiqEventsResult } from '../util/transformers';
import { ChartIQContentDataProviderConfig } from './ChartIQContentDataProviderConfig';
/**
 * Handling data for chartIQ Content with push support
 */
var ChartIQContentNoPushDataProvider = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param client
     * @param config
     */
    function ChartIQContentNoPushDataProvider(client, config) {
        /**
         * Holds data of notations
         */
        this.refData = new Map();
        /**
         * Holds trading schedule list data of the main notation
         */
        this.eventList = {};
        /**
         * Map chart price type
         */
        this.priceTypes = new Map([['Last', 'trade'], ['Bid', 'bid'], ['Ask', 'ask']]);
        /**
         * Used to cache current price data per notation
         */
        this.cacheHistoricData = new Map();
        this.client = client;
        this.config = __assign(__assign({}, new ChartIQContentDataProviderConfig()), config);
    }
    /**
     * Gets historic price data
     *
     * @param params The params object
     */
    ChartIQContentNoPushDataProvider.prototype.getHistoricData = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var isEod, cacheData, queryLastMinutes, historicData, pricesData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isEod = params.rangeType === 'eod';
                        cacheData = this.getHistoricDataFromCache(params);
                        queryLastMinutes = false;
                        historicData = [];
                        if (cacheData !== null && cacheData !== undefined) {
                            if (isEod) {
                                return [2 /*return*/, cacheData];
                            }
                            historicData = cacheData;
                            queryLastMinutes = true;
                        }
                        return [4 /*yield*/, this.getPricesHistoricData(params, { queryLastMinutes: queryLastMinutes })];
                    case 1:
                        pricesData = _a.sent();
                        pricesData.forEach(function (entry) {
                            if (entry && entry.data) {
                                var resultData = entry.data.subsamples || entry.data.prices || [];
                                // Replaces the "lastMinutes" data;
                                if (queryLastMinutes && historicData.length >= resultData.length) {
                                    historicData.splice.apply(historicData, __spreadArrays([historicData.length - resultData.length, resultData.length], resultData));
                                }
                                else {
                                    historicData.push.apply(historicData, resultData);
                                }
                            }
                        });
                        this.setCacheHistoricData(params, historicData);
                        return [2 /*return*/, historicData];
                }
            });
        });
    };
    /**
     * Gets data for given Notation
     */
    ChartIQContentNoPushDataProvider.prototype.getReferenceData = function (idNotation) {
        return __awaiter(this, void 0, void 0, function () {
            var id, endpointInstrument, endpointNotation, endpointMarket, instrumentDataPromise, notationDataPromise, instrumentData, data, notationData, marketId, marketData, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = String(idNotation);
                        endpointInstrument = this.config.API_INSTRUMENT_GET_BY_NOTATION;
                        endpointNotation = this.config.API_NOTATION;
                        endpointMarket = this.config.API_BASIC_MARKET;
                        if (this.refData.has(id)) {
                            return [2 /*return*/, this.refData.get(id)];
                        }
                        instrumentDataPromise = this.client.requestEndpoint('GET', endpointInstrument, { id: id });
                        notationDataPromise = this.client.requestEndpoint('GET', endpointNotation, { id: id });
                        return [4 /*yield*/, instrumentDataPromise];
                    case 1:
                        instrumentData = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, notationDataPromise];
                    case 3:
                        notationData = _a.sent();
                        marketId = notationData.data.market.id;
                        return [4 /*yield*/, this.client.requestEndpoint('GET', endpointMarket, { id: marketId })];
                    case 4:
                        marketData = _a.sent();
                        data = __assign(__assign({}, instrumentData.data), { NameInstrument: instrumentData.data.name, NameCurrency: notationData.data.valueUnit.code, NameExchange: notationData.data.market.name, NameExchangeShort: marketData.data.shortName });
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        /* In case the user doesn't have the endpoints above in their CAS yet */
                        data = __assign(__assign({}, instrumentData.data), { NameInstrument: instrumentData.data.name });
                        return [3 /*break*/, 6];
                    case 6:
                        this.refData.set(id, data);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Gets trading open and close time in last API_PRICES_LAST_DAYS for given notation
     *
     * @param idNotation
     */
    ChartIQContentNoPushDataProvider.prototype.getTradingScheduleEvents = function (idNotation) {
        return __awaiter(this, void 0, void 0, function () {
            var id, endpoint, lastDays, start, end, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = String(idNotation);
                        endpoint = this.config.API_PRICES_TRADING_SCHEDULE_EVENT_LIST;
                        lastDays = this.config.API_PRICES_LAST_DAYS;
                        start = moment().utc().subtract(lastDays, 'days').startOf('day').toISOString();
                        end = moment().utc().endOf('day').toISOString();
                        return [4 /*yield*/, this.client.requestEndpoint('POST', endpoint, {
                                data: {
                                    id: id,
                                    filter: {
                                        types: [TRADING_EVENT_TYPE.OPEN, TRADING_EVENT_TYPE.CLOSE],
                                        range: { start: start, end: end },
                                    },
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, this.eventList.eventList = transformCiqEventsResult(result)];
                }
            });
        });
    };
    /**
     * Formatter for all y axis values
     *
     * @param value
     * @param options
     */
    ChartIQContentNoPushDataProvider.prototype.formatValue = function (value, options) {
        if (typeof this.config.FUNC_FORMAT_VALUE !== 'function') {
            return value;
        }
        return this.config.FUNC_FORMAT_VALUE.call(this, value, options);
    };
    /**
     * Formatter for all x axis values
     *
     * @param value
     * @param intraday
     */
    ChartIQContentNoPushDataProvider.prototype.formatDateTime = function (value, intraday) {
        if (typeof this.config.FUNC_FORMAT_DATE_TIME !== 'function') {
            return value;
        }
        return this.config.FUNC_FORMAT_DATE_TIME.call(this, value, intraday);
    };
    /**
     * Reset states
     */
    ChartIQContentNoPushDataProvider.prototype.destroy = function () {
        this.refData = new Map();
        this.eventList = {};
        this.cacheHistoricData = new Map();
    };
    /**
     * Fetches prices data
     *
     * @param params
     * @param option
     */
    ChartIQContentNoPushDataProvider.prototype.getPricesHistoricData = function (params, option) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, API_PRICES_QUALITY, API_PRICES_TSS_CHART_IQ_EOD_LIST, API_PRICES_TSS_CHART_IQ_INTRADAY_SUBSAMPLE_LIST, API_PRICES_LAST_YEARS, API_PRICES_LAST_DAYS, API_PRICES_REQUEST_CHUNK_YEARS, API_PRICES_REQUEST_CHUNK_DAYS, isEod, unit, lastYearsOrDays, type, quality, granularity, id, endpoint, start, end, requests, requestCount, requestChunk, lastMinutes, i, chunkStart, chunkEnd, request;
            return __generator(this, function (_b) {
                _a = this.config, API_PRICES_QUALITY = _a.API_PRICES_QUALITY, API_PRICES_TSS_CHART_IQ_EOD_LIST = _a.API_PRICES_TSS_CHART_IQ_EOD_LIST, API_PRICES_TSS_CHART_IQ_INTRADAY_SUBSAMPLE_LIST = _a.API_PRICES_TSS_CHART_IQ_INTRADAY_SUBSAMPLE_LIST, API_PRICES_LAST_YEARS = _a.API_PRICES_LAST_YEARS, API_PRICES_LAST_DAYS = _a.API_PRICES_LAST_DAYS, API_PRICES_REQUEST_CHUNK_YEARS = _a.API_PRICES_REQUEST_CHUNK_YEARS, API_PRICES_REQUEST_CHUNK_DAYS = _a.API_PRICES_REQUEST_CHUNK_DAYS;
                isEod = params.rangeType === 'eod';
                unit = isEod ? 'years' : 'days';
                lastYearsOrDays = isEod ? API_PRICES_LAST_YEARS : API_PRICES_LAST_DAYS;
                type = this.priceTypes.get(params.priceType);
                quality = API_PRICES_QUALITY;
                granularity = isEod ? undefined : '1m';
                id = String(params.idNotation);
                endpoint = isEod ? API_PRICES_TSS_CHART_IQ_EOD_LIST : API_PRICES_TSS_CHART_IQ_INTRADAY_SUBSAMPLE_LIST;
                start = moment().utc().subtract(lastYearsOrDays, unit).startOf('day');
                if (option.queryLastMinutes) {
                    start = moment().utc().subtract(60, 'minute').startOf('minute');
                }
                end = moment().utc().startOf(isEod ? 'day' : 'minute');
                requests = [];
                requestCount = isEod ? lastYearsOrDays - 1 : lastYearsOrDays;
                requestChunk = isEod ? API_PRICES_REQUEST_CHUNK_YEARS : API_PRICES_REQUEST_CHUNK_DAYS;
                if (option.queryLastMinutes) {
                    lastMinutes = this.createRequest(start, end, type, quality, granularity, id, endpoint);
                    requests.push(lastMinutes);
                }
                else {
                    // Create several requests and concatenate the result
                    for (i = 0; i < requestCount; i += requestChunk) {
                        chunkStart = start.clone().add(i, unit);
                        chunkEnd = i < requestCount - requestChunk ? start.clone().add(i + requestChunk, unit) : end;
                        request = this.createRequest(chunkStart, chunkEnd, type, quality, granularity, id, endpoint);
                        requests.push(request);
                    }
                }
                return [2 /*return*/, Promise.all(requests)];
            });
        });
    };
    /**
     * Create request to endpoint
     *
     * @param start
     * @param end
     * @param type
     * @param quality
     * @param granularity
     * @param id
     * @param endpoint
     */
    ChartIQContentNoPushDataProvider.prototype.createRequest = function (start, end, type, quality, granularity, id, endpoint) {
        var data = {
            data: {
                type: type,
                quality: quality,
                granularity: granularity,
                id: id,
                range: {
                    start: start.toISOString(),
                    end: end.toISOString(),
                },
            },
            meta: {
                pagination: {
                    limit: 5000,
                },
            },
        };
        return this.client.requestEndpoint('POST', endpoint, data);
    };
    /**
     * Cache key for historic data
     *
     * @param params
     */
    ChartIQContentNoPushDataProvider.prototype.getCacheHistoricKey = function (params) {
        return [params.idNotation, params.rangeType, params.priceType, params.withEarnings].join('_');
    };
    /**
     * Cache historic data
     *
     * @param params
     * @param data
     */
    ChartIQContentNoPushDataProvider.prototype.setCacheHistoricData = function (params, data) {
        var key = this.getCacheHistoricKey(params);
        this.cacheHistoricData.set(key, data);
    };
    /**
     * Gets historic data from cache
     *
     * @param params
     */
    ChartIQContentNoPushDataProvider.prototype.getHistoricDataFromCache = function (params) {
        var cacheKey = this.getCacheHistoricKey(params);
        return this.cacheHistoricData.get(cacheKey);
    };
    return ChartIQContentNoPushDataProvider;
}());
export { ChartIQContentNoPushDataProvider };
//# sourceMappingURL=ChartIQContentNoPushDataProvider.js.map